import { observer } from "mobx-react";
import { SignersForm } from "../common/commonForms";
import { useTranslation } from "../stores/RootStoreContext";
import { DataTable, TableColumn } from "../components-v2/DataTable";
import { Box, VBox } from "../components-v2/Box";
import { Icon } from "../components-v2/Icon";
import { Dialog } from "../components-v2/Dialog";
import { Alert } from "../components-v2/Alert";
import { MSelect } from "../components-v2/Select";
import { LoadingIndicator } from "../components-v2/LoadingIndicator";
import { LinkButton } from "../components-v2/Button";
import { SharepointContentInDrive } from "./sharepointDomain";

export const ConfigureSharepointDestination = observer(({ form }: { form: SignersForm }) => {
  const { t } = useTranslation();
  const renderLink = (label: string) => (
    <LinkButton
      label={label}
      icon={"folder-open"}
      onClick={form.toggleSelectSharepointDestinationDialog}
      weight={"normal"}
    />
  );
  return (
    <Box alignItems={"center"}>
      {form.selectSharepointDestinationDialog && <SelectSharepointDestination form={form} />}
      <Box gap={"md"} alignItems={"center"}>
        {form.selectedSharepointDestination ? (
          <>
            <Icon name={"folder"} /> {form.selectedSharepointDestination.destinationFolderName}
            {renderLink(t("edit"))}
            <LinkButton
              weight={"normal"}
              label={t("reset")}
              icon={"arrow-counter-clockwise"}
              onClick={form.resetSharepointDestination}
            />
          </>
        ) : (
          renderLink(t("dbot.select-sharepoint-destination"))
        )}
      </Box>
    </Box>
  );
});

const SelectSharepointDestination = observer(({ form }: { form: SignersForm }) => {
  const { t } = useTranslation();
  const columns: TableColumn<SharepointContentInDrive>[] = [
    {
      align: "left",
      name: "name",
      label: "",
      getValue: (d) => (
        <Box>
          <Icon name={"folder"} /> {d.name}
        </Box>
      ),
    },
  ];

  return (
    <Dialog
      title={t("dbot.select-sharepoint-destination")}
      maxWidth={"sm"}
      onCancel={form.toggleSelectSharepointDestinationDialog}
      onSubmit={form.onSelectSharepointDestination}
      submitLabel={form.selectSharepointLabel}
    >
      <VBox gap={"md"}>
        {form.error && <Alert message={form.error} type={"error"} />}
        <MSelect model={form.sharepointDrive} />
        {form.sharepointParent && (
          <div>
            <LinkButton
              arrow={"left"}
              label={form.sharepointParent.name}
              onClick={form.navigateToParent}
            />
          </div>
        )}
        {form.isLoading && <LoadingIndicator />}
        {form.contentInSharepointDrive &&
          (form.contentInSharepointDrive.length > 0 ? (
            <DataTable
              tableColumns={columns}
              tableData={form.contentInSharepointDrive}
              getId={(p) => p.id}
              onRowClick={(p) => form.loadContentInSharepointDrive(form.sharepointDrive.value, p)}
            />
          ) : (
            <Alert type={"info"} message={t("sharepoint.no-content")} />
          ))}
      </VBox>
    </Dialog>
  );
});
